import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useHeaderStore = defineStore('headerStore', () => {
    const headerEl = ref<HTMLElement | null>(null);

    const setHeaderStyles = (styles: Partial<CSSStyleDeclaration>) => {
        if (!headerEl.value) return;
        Object.assign(headerEl.value.style, styles);
    };

    return { headerEl, setHeaderStyles };
});
